<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />
    <site-device-query :options="filterSites" :query="query" />
    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="formatDataList"
        :span-method="spanMethod"
        height="100%"
        border
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table"
        style="width:100%"
      >
        <el-table-column label="站点" prop="siteName" width="100" />
        <el-table-column label="设备" prop="siteDeviceName" width="170" />
        <el-table-column label="填报日期" prop="opDate" width="100" align="center" />
        <el-table-column label="异常时段" prop="errTime" width="110" align="center">
          <template slot-scope="{row}">
            <div
              v-for="(times, index) in JSON.parse(row.errTime || '[]')"
              :key="index"
            >{{times[0].toString().padStart(2, '0')}}时{{times[1] === times[0] ? '' : ` 至 ${times[1].toString().padStart(2, '0')}时`}}</div>
          </template>
        </el-table-column>
        <el-table-column label="主要问题" prop="trouble" />
        <el-table-column label="解决计划" prop="solution" />
        <el-table-column label="填报人" prop="submitOrgName" />
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{row}"><span :log-status="row.status">{{statusMap[row.status].label}}</span></template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{row}">
            <!--          <div v-if="row.id && (row.status & 1073741825) > 0">-->
            <!--            <el-button type="warning" size="mini" @click="onEditBtnClick(row)">编辑</el-button>-->
            <!--            <el-button type="success" size="mini" @click="onSubmitBtnClick(row)">提交</el-button>-->
            <!--          </div>-->
            <!--          <div v-else-if="row.status === 1" class="table-operator-wrapper">-->
            <!--            <el-button type="primary" size="mini" @click="onNormalBtnClick(row)">正常</el-button>-->
            <!--            <el-button type="danger" size="mini" @click="onEditBtnClick(row)">异常录入</el-button>-->
            <!--          </div>-->
            <div v-if="(row.status & 1073741825) > 0">
              <el-button type="warning" size="mini" @click="onEditBtnClick(row)">编辑</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </data-wrapper>
  </template>

  <template #editor>
    <editor ref="editor" @save="getData" />
  </template>
</layout-content>
</template>

<script>
import BaseDateData from '../../../BaseDateData'
import SiteDeviceQuery from '../../../../components/Data/Query/SiteDeviceQuery'
import Editor from './Editor'
import statusMap from '../statusMap'
import DataWrapper from '../../../../components/Data/DataWrapper'

export default {
  name: 'OperationsLogSubmit',
  routeInfo: {
    label: '日志提交',
    icon: 'fa fa-users'
  },
  extends: BaseDateData,
  components: {DataWrapper, Editor, SiteDeviceQuery},
  data () {
    return {
      query: {
        siteDeviceIds: []
      },
      currentQuery: Object.freeze({}),
      dataMap: Object.freeze({})
    }
  },
  computed: {
    queryTimeStep: () => 1,
    statusMap: () => statusMap,
    filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {profileSites} = this

      if (profileSites.length === 0) {
        return []
      }

      let siteDeviceMap = profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let siteDevices = map[siteId]

        if (!Array.isArray(siteDevices)) {
          siteDevices = map[siteId] = []
        }

        siteDevices.push(siteDevice)

        return map
      }, {})

      return Object.values(profileSites.reduce((map, site) => {
        let siteId = site.id

        if (siteDeviceMap.hasOwnProperty(siteId)) {
          map[siteId] = {
            value: siteId,
            label: site.name,
            children: siteDeviceMap[siteId].map(siteDevice => ({
              value: siteDevice.id,
              label: siteDevice.name
            }))
          }
        }

        return map
      }, {}))
    },
    days () {
      let {currentQuery} = this
      let beginTS = new Date(currentQuery.beginTime)
      let endTS = new Date(currentQuery.endTime)
      return Math.ceil((endTS - beginTS) / 86400000)
    },
    canNotSearch () {
      return this.query.siteDeviceIds.length === 0
    },
    formatDataList () {
      let {profileSiteMap, profileSiteDeviceMap} = this
      return Object.values(this.dataMap).reduce((list, siteData) => Object.values(siteData).reduce((list, siteDeviceData) => siteDeviceData.reduce((list, data) => {
        list.push({
          siteName: profileSiteMap[data.siteId].name,
          siteDeviceName: profileSiteDeviceMap[data.siteDeviceId].name,
          ...data
        })
        return list
      }, list), list), [])
    },
    rowSpanMap () {
      let lastSiteId
      let lastSiteDeviceId
      return this.formatDataList.reduce((map, data, index) => {
        let {siteId, siteDeviceId} = data

        if (siteId !== lastSiteId) {
          map.site[index] = true
          lastSiteId = siteId
        }

        if (siteDeviceId !== lastSiteDeviceId) {
          lastSiteDeviceId = siteDeviceId
          map.siteDevice[index] = true
        }

        return map
      }, {
        site: {},
        siteDevice: {}
      })
    }
  },
  methods: {
    setSiteDeviceIds (sites) {
      if (sites.length > 0) {
        let {query} = this

        if (query.siteDeviceIds.length === 0) {
          query.siteDeviceIds = sites[0].children.map(siteDevice => siteDevice.value)
        }

        setTimeout(() => {
          this.search()
        }, 0)
      }
    },
    search () {
      this.setCurrentQuery()
      this.getData()
    },
    setCurrentQuery () {
      this.currentQuery = Object.freeze(JSON.parse(JSON.stringify(this.query)))
    },
    getData () {
      let {currentQuery} = this
      this.changeLoadStatus(true)
      this.$api.Operations.getList({
        beginTime: currentQuery.beginTime,
        endTime: currentQuery.endTime,
        siteDeviceIds: currentQuery.siteDeviceIds
      }).then(this.setDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setDataList (dataList) {
      let {currentQuery, profileSiteDeviceMap, days} = this
      let beginTS = new Date(currentQuery.beginTime).getTime()
      let dataTimes = []

      for (let i = 0; i < days; i++) {
        let date = new Date(beginTS + (i * 86400000))
        dataTimes.push({
          ts: date.getTime(),
          dataTime: date.format('YYYY/MM/DD')
        })
      }

      let dataMap = currentQuery.siteDeviceIds.reduce((map, siteDeviceId) => {
        let siteDevice = profileSiteDeviceMap[siteDeviceId]
        let {siteId} = siteDevice

        if (!map.hasOwnProperty(siteId)) {
          map[siteId] = {}
        }

        map[siteId][siteDeviceId] = dataTimes.map(dataTime => ({
          ts: dataTime.ts,
          opDate: dataTime.dataTime,
          siteId,
          siteDeviceId,
          status: 1
        }))

        return map
      }, {})

      dataList.forEach(data => {
        let {siteId, siteDeviceId} = data
        let index = (new Date(data.opDate + ' 00:00:00').getTime() - beginTS) / 86400000
        let tableData = dataMap[siteId][siteDeviceId][index]
        tableData.id = data.id
        tableData.errTime = data.errTime
        tableData.solution = data.solution
        tableData.trouble = data.trouble
        tableData.submitOrgName = data.submitOrgName
        tableData.status = data.status
      })

      this.dataMap = Object.freeze(dataMap)
    },
    spanMethod ({row, columnIndex, rowIndex}) {
      let {days, rowSpanMap} = this

      switch (columnIndex) {
        case 0:
          let {dataMap} = this
          let {siteId} = row
          let siteColumnSpan = -rowSpanMap.site[rowIndex]

          return {
            rowspan: siteColumnSpan & (Object.values(dataMap[siteId]).length * days),
            colspan: siteColumnSpan & 1
          }
        case 1:
          let siteDeviceColumnSpan = -rowSpanMap.siteDevice[rowIndex]

          return {
            rowspan: siteDeviceColumnSpan & days,
            colspan: siteDeviceColumnSpan & 1
          }
      }
    },
    onSearchBtnClick () {
      this.search()
    },
    onNormalBtnClick (data) {
      let tmpData = JSON.parse(JSON.stringify(data))
      tmpData.trouble = '/'
      tmpData.solution = '/'

      this.changeLoadStatus(true)
      this.$api.Operations.save(tmpData, 1).then(data => {
        this.$confirm('是否提交本次的内容?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirm-dialog-confirm-btn',
          cancelButtonClass: 'confirm-dialog-cancel-btn',
          type: 'info'
        }).then(() => {
          this.onSubmitBtnClick(data)
        }).catch(this.getData)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onEditBtnClick (data) {
      this.$refs.editor.open(data)
    },
    onSubmitBtnClick (data) {
      this.changeLoadStatus(true)
      this.$api.Operations.submit([data.id]).then(this.getData).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  },
  watch: {
    filterSites: {
      immediate: true,
      handler (newVal) {
        this.setSiteDeviceIds(newVal)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
[log-status="1"] {
  color: #F56C6C;
}

[log-status="1073741824"] {
  color: #E6A23C;
}

[log-status="4"] {
  color: #67C23A;
}
</style>



// WEBPACK FOOTER //
// src/views/08Operations/02Log/01Submit/index.vue